// extracted by mini-css-extract-plugin
module.exports = {"RegisterCardHeader":"RegisterCardHeader_RegisterCardHeader__2F_Pi","RegisterCardHeader__exit":"RegisterCardHeader_RegisterCardHeader__exit__13WoT"};